import Button from '@/components/Button';
import useSearch from '@/components/search/useSearch';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import StoreTable from '@/modules/supplier/components/StoreTable';
import { CustomerStoreAddPath } from '@/modules/supplier/paths';
import { BuildingStorefrontIcon } from '@heroicons/react/24/outline';
import { LinkIcon } from '@heroicons/react/24/solid';
import { useParams } from 'react-router-dom';

const StoreList = () => {
  const { currentUser } = useAuth();

  const supplierId = currentUser()?.supplierId;

  const { customerId } = useParams();

  const { page, handlePageChange } = useSearch();

  return (
    <>
      <SettingsHeader title="Stores" icon={<BuildingStorefrontIcon className="w-6 h-6" />}>
        {customerId && (
          <Button
            to={CustomerStoreAddPath.withCustomerId(customerId)}
            icon={<LinkIcon className="h-5 w-5 mr-1" />}
            variant="secondary"
          >
            Link Store
          </Button>
        )}
      </SettingsHeader>

      <StoreTable
        page={page}
        onChangePage={handlePageChange}
        supplierId={!customerId ? supplierId : undefined}
        customerId={customerId}
      />
    </>
  );
};

export default StoreList;
